import classNames from "classnames"
import * as solidIcons from "@heroicons/react/20/solid"
import * as outlineIcons from "@heroicons/react/24/outline"
import camelCase from "lodash.camelcase"
import startCase from "lodash.startcase"

const devErrorMessage = (message) => {
  if (process.env.NODE_ENV !== "production") {
    console.error(message)
  }
}

export default function Icon({
  name,
  title,
  width = "20px",
  height = "20px",
  outline = false,
  fadeUntilHover = false,
  className,
  ...rest
}) {
  if (!name) {
    devErrorMessage("Icon: Name required")
    return null
  }

  const iconCompSrc = outline ? outlineIcons : solidIcons
  let iconName = `${startCase(camelCase(name)).replace(/ /g, "")}Icon`

  if (iconName === "XcircleIcon") {
    iconName = "XCircleIcon"
  }

  const classes = classNames(className, {
    "opacity-50 hover:opacity-100": fadeUntilHover,
  })

  const Icon = iconCompSrc[iconName]

  if (!Icon) {
    devErrorMessage(
      `Icon: Unknown icon ${name} (${iconName}), please see https://heroicons.com for valid names`
    )
    return null
  }

  return (
    <span title={title}>
      <Icon width={width} height={height} className={classes} {...rest} />
    </span>
  )
}
